export default "__VITE_ASSET__B2rPGQ0f__"